import { protectedApi } from './requester'

export type UserAccessRoles = string

export const updateAccessRoles = async (
  username: string,
  roles: UserAccessRoles,
): Promise<number> => {
  return protectedApi
    .put<void>(`/user/${username}/roles`, { roles: roles })
    .then((response) => response.status)
}
